export default __webpack_public_path__ + "static/media/drop.1eec5941.svg";